import React from 'react';
import { Stack, Paper, Typography, Alert } from '@mui/material';
import { useAppSelector } from '../../../../app/store';
import { useGetCaseManagementQuery } from '../../../../services/CaseManagementService';
import { useSearchParams } from 'react-router-dom';
import { Diagnosis1Field, Diagnosis2Field, Diagnosis3Field, Diagnosis4Field, Dx1CoverageStatusField, Dx2CoverageStatusField, Dx3CoverageStatusField, Dx4CoverageStatusField } from '../fieldEditors/caseMan/codingReview';
import { CodingReviewActions, CodingReviewStamp } from '../commands';

const CodingReviewTab: React.FC = () => {
  const [searchParams] = useSearchParams();
  const caseId = searchParams.get('id');
  
  const { currentCase } = useAppSelector(state => state.caseManage);
  const { data: caseData } = useGetCaseManagementQuery(
    { id: caseId! }, 
    { skip: !caseId }
  );
  
  const medNecAlerts = currentCase?.codingDetails?.medNecAlerts || caseData?.codingDetails?.medNecAlerts || [];

  const SECTION_PAPER_STYLE = {
    p: 2,
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: 1.5
  };

  const ALERT_PAPER_STYLE = {
    p: 2,
    backgroundColor: '#fef3c7',
    border: '1px solid #f59e0b',
    borderRadius: 1.5
  };

  if (!(caseData || currentCase)) return null;

  return (
    <Stack spacing={4}>
      {/* Action Buttons and Status Stamp */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <CodingReviewActions />
        <CodingReviewStamp caseData={caseData} />
      </Stack>

      {/* Diagnosis Codes Section */}
      <Paper elevation={0} sx={SECTION_PAPER_STYLE}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          Diagnosis Codes
        </Typography>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Diagnosis1Field />
              <Dx1CoverageStatusField />
            </Stack>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Diagnosis2Field />
              <Dx2CoverageStatusField />
            </Stack>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Diagnosis3Field />
              <Dx3CoverageStatusField />
            </Stack>
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Diagnosis4Field />
              <Dx4CoverageStatusField />
            </Stack>
          </Stack>
        </Stack>
      </Paper>

      {/* Medical Necessity Alerts */}
      {medNecAlerts.length > 0 && (
        <Paper elevation={0} sx={ALERT_PAPER_STYLE}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#92400e', mb: 2 }}>
            Medical Necessity Alerts
          </Typography>
          <Stack spacing={1}>
            {medNecAlerts.map((alert: string, index: number) => (
              <Alert key={index} severity="warning" sx={{ fontSize: '0.875rem' }}>
                {alert}
              </Alert>
            ))}
          </Stack>
        </Paper>
      )}
    </Stack>
  );
};

export default CodingReviewTab;
